import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faBars } from '@fortawesome/free-solid-svg-icons';

const HolidaySidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Internal state to track if sidebar is collapsed or expanded
  const [isCollapsed, setIsCollapsed] = useState(false);

  const navItems = [
    { icon: "📊", label: "Dashboard", path: "/holidaydashboard" },
    { icon: "➕", label: "New Package", path: "/dmcpackagecreate" },
    { icon: "🎁", label: "Packages", path: "/dmcpackageslist" },
    { icon: "📅", label: "Bookings", path: "/dmcpackageenquiries" },
  ];

  // inside HolidaySidebar.js
return (
    <aside className={`holidaydashboard-sidebar`}>
      <nav className="holidaydashboard-sidebar-nav">
        {navItems.map((item, index) => (
          <button
            key={index}
            className={`holidaydashboard-nav-item ${
              location.pathname === item.path ? "holidaydashboard-nav-item-active" : ""
            }`}
            onClick={() => navigate(item.path)}
          >
            <span className="holidaydashboard-nav-icon">{item.icon}</span>
            {/* The label is hidden via CSS when .collapsed-sidebar is active */}
            <span className="holidaydashboard-nav-label">{item.label}</span>
          </button>
        ))}
      </nav>
    </aside>
);
};

export default HolidaySidebar;